import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import {
  ColorPickerStandaloneControl,
  ColorPickerStandaloneControlProps,
} from 'src/editor/shared/settings/controls/color-picker/color-picker-standalone-control'

export interface ColorPickerControlProps
  extends ColorPickerStandaloneControlProps {
  label?: string
  singleColorMode?: boolean
}

export const ColorPickerControl = ({
  label = 'settings_styles.color.label',
  singleColorMode = false,
  ...props
}: ColorPickerControlProps) => {
  const { isMobile } = useDeviceModeContext()

  return (
    <OptionWrapper
      directionRow
      labelClassName="text-textPrimary"
      labelText={label}
      labelIcon={isMobile && !singleColorMode && <MobileIconUi />}
    >
      <ColorPickerStandaloneControl
        popoverProps={{
          ignoredEventTypes: [],
        }}
        {...props}
      />
    </OptionWrapper>
  )
}
